export enum LocalStorageKeys {
  DETAILED_OFFLINE_NETWORK_WARNING_DISMISSED = 'detailedOfflineNetworkWarningDismissed',
  HIDE_CANCELED_ACTIVITIES = 'hideCanceledActivities',
  SIDE_NAVIGATION_COLLAPSED = 'sideNavigationCollapsed'
}
